import {useFormContext, useWatch} from 'react-hook-form';
import {FieldPath} from 'react-hook-form/dist/types/path';
import {IEmptyModel} from '../@interfaces/IEmptyModel';
import app from '../helpers/app';

export default function useFormValue<
    Model extends IEmptyModel = IEmptyModel,
    TRes = any
>(name: string | FieldPath<Model>) {
    const {control, formState: {defaultValues}} = useFormContext();
    const value = useWatch({control, name});

    return {
        currentValue: value as TRes,
        defaultValue: app('dot-accessor').get(defaultValues ?? {}, name) as TRes,
    };
}
